import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo, SITE_NAME } from '@/hooks/useSeo';
import HomeHero from './components/HomeHero';
import CategorySection from './components/CategorySection';
import HotSection from './components/HotSection';
import LatestSection from './components/LatestSection';
import FaqSection, { FAQS } from './components/FaqSection';
import BrandBand from './components/BrandBand';
import SearchResultsSection from './components/SearchResultsSection';

const SITE_DESCRIPTION =
  '17吃瓜网按娱乐区、社会区、科技圈、体育圈与网红圈做板块分区，点进对应分区就能看到该板块最近的八卦和话题更新，不用一个个翻。';

export default function Home() {
  const [searchParams] = useSearchParams();
  const keyword = (searchParams.get('q') ?? '').trim();

  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  const jsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: SITE_NAME,
        url: `${origin}/`,
        description: SITE_DESCRIPTION,
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${origin}/?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: SITE_NAME,
        url: `${origin}/`,
        description: SITE_DESCRIPTION,
        email: 'hello@17chigua.example',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: FAQS.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: { '@type': 'Answer', text: item.answer },
        })),
      },
    ],
    [origin],
  );

  useSeo({
    title: '17吃瓜网 - 娱乐区、社会区、网红圈等分区入口',
    description: SITE_DESCRIPTION,
    keywords: '17吃瓜网,娱乐区,社会区,网红圈,科技圈,体育圈,板块导航',
    path: '/',
    jsonLd,
  });

  return (
    <SiteLayout>
      <HomeHero />
      {keyword && <SearchResultsSection keyword={keyword} />}
      <CategorySection />
      <HotSection />
      <LatestSection />
      <BrandBand />
      <FaqSection />
    </SiteLayout>
  );
}